import React from 'react';
import { useTranslation } from 'react-i18next';
import './StaticPages.css';

const TermsOfServicePage = () => {
    const { t } = useTranslation();

   return (
        <div className="page-container static-page legal-page">
            <div className="static-header">
                <h1>{t('terms_title')}</h1>
                <p className="last-updated">{t('last_updated_agreement')}</p>
            </div>
            
            <div className="legal-content">
                <h2>{t('terms_h2_intro')}</h2>
                <p>{t('terms_p_intro')}</p>

                <h2>{t('terms_h2_responsibilities')}</h2>
                <ul>
                    <li>{t('terms_li_resp1')}</li>
                    <li>{t('terms_li_resp2')}</li>
                    <li>{t('terms_li_resp3')}</li>
                </ul>

                <h2>{t('terms_h2_payment')}</h2>
                <p>{t('terms_p_payment')}</p>
                
                <h2>{t('terms_h2_termination')}</h2>
                <p>{t('terms_p_termination')}</p>

                <h2>{t('terms_h2_disputes')}</h2>
                <p>{t('terms_p_disputes')}</p>

                <h2>{t('terms_h2_changes')}</h2>
                <p>{t('terms_p_changes')}</p>
            </div>
        </div>
    );

};

export default TermsOfServicePage;